import { gql } from '@graphql/__generated__';

export const GET_PROPERTY_SEARCHES_LIST = gql(/* GraphQL */ `
  query GetPropertySearchesList(
    $where: property_searches_bool_exp!
    $order_by: [property_searches_order_by!]
    $limit: Int!
    $offset: Int!
  ) {
    property_searches(
      where: $where
      order_by: $order_by
      limit: $limit
      offset: $offset
    ) {
      id
      created_at
      user {
        id
        ...UserInfo_user
      }
      property_searches_places {
        place {
          id
          name
          label
        }
      }
      property_types {
        property_type {
          id
          label
          type
          composite_type_object {
            id
            label
          }
        }
      }
      offer_type
      property_usage
      notification
      source
      aggregator_source
      property_main_type_in
      property_main_type_nin
      composite_property_type_eq
      sale_price_lte
      sale_price_gte
      monthly_rent_lte
      monthly_rent_gte
      living_surface_lte
      living_surface_gte
      land_surface_lte
      land_surface_gte
      number_of_rooms_lte
      number_of_rooms_gte
      number_of_bedrooms_lte
      number_of_bedrooms_gte
      number_of_bathrooms_lte
      number_of_bathrooms_gte
    }
  }
`);

export const GET_PROPERTY_SEARCHES_COUNT = gql(/* GraphQL */ `
  query GetPropertySearchesCount(
    $where: property_searches_bool_exp!
    $limit: Int
  ) {
    property_searches_aggregate(where: $where, limit: $limit) {
      aggregate {
        count
      }
    }
  }
`);

export const GET_PROPERTY_SEARCH_DRAWER = gql(/* GraphQL */ `
  query GetPropertySearchDrawer($id: uuid!) {
    property_searches_by_pk(id: $id) {
      id
      created_at
      created_by
      source
      aggregator_source
      user {
        id
        teams_users {
          team_id
        }
      }
      ...PropertySearchForm
    }
    dictionaries(
      where: {
        type: { _eq: enums }
        _or: [
          { name: { _like: "property_search_source.%" } }
          { name: { _like: "property_search_aggregator_source.%" } }
        ]
      }
    ) {
      id
      name
      label
    }
  }
`);

export const INSERT_PROPERTY_SEARCH = gql(/* GraphQL */ `
  mutation InsertPropertySearch($object: property_searches_insert_input!) {
    insert_property_searches_one(object: $object) {
      id
      created_at
      source
      aggregator_source
      ...PropertySearchForm
    }
  }
`);

export const IMPORT_PROPERTY_SEARCHES = gql(/* GraphQL */ `
  mutation ImportPropertySearches($objects: [PropertySearchImportInput!]!) {
    import_property_searches(objects: $objects) {
      property_search_id
      property_search {
        id
        user {
          id
        }
        property_searches_places {
          place {
            id
          }
        }
      }
    }
  }
`);

export const UPDATE_PROPERTY_SEARCHES = gql(/* GraphQL */ `
  mutation UpdatePropertySearches(
    $id: uuid!
    $propertySearch: property_searches_set_input!
    $propertyPlaces: [property_searches_places_insert_input!]!
    $propertyTypes: [property_searches_property_types_insert_input!]!
  ) {
    update_property_searches_by_pk(
      pk_columns: { id: $id }
      _set: $propertySearch
    ) {
      id
      ...PropertySearchForm
    }
    delete_property_searches_places(
      where: { property_search_id: { _eq: $id } }
    ) {
      affected_rows
    }
    insert_property_searches_places(objects: $propertyPlaces) {
      returning {
        property_search_id
        place {
          id
          name
          label
        }
      }
    }
    delete_property_searches_property_types(
      where: { property_search_id: { _eq: $id } }
    ) {
      affected_rows
    }
    insert_property_searches_property_types(objects: $propertyTypes) {
      returning {
        property_type {
          id
          label
          type
          composite_type_object {
            id
            label
            name
          }
        }
      }
    }
  }
`);

export const DELETE_PROPERTY_SEARCHES = gql(/* GraphQL */ `
  mutation DeletePropertySearches($ids: [uuid!]!) {
    delete_property_searches(where: { id: { _in: $ids } }) {
      affected_rows
    }
  }
`);

export const EXPORT_PROPERTY_SEARCHES = gql(/* GraphQL */ `
  query ExportPropertySearches($where: property_searches_bool_exp!) {
    property_searches(where: $where) {
      id
      created_at
      user {
        id
        full_name
        emails {
          email
        }
        phone_numbers {
          number
        }
      }
      property_searches_places {
        place {
          name
          slug_en
        }
      }
      offer_type
      property_usage
      notification
      source
      property_main_type_in
      property_main_type_nin
      sale_price_lte
      sale_price_gte
      monthly_rent_lte
      monthly_rent_gte
      living_surface_lte
      living_surface_gte
      land_surface_lte
      land_surface_gte
      number_of_rooms_lte
      number_of_rooms_gte
      number_of_bedrooms_lte
      number_of_bedrooms_gte
    }
  }
`);

export const GET_PROPERTY_SEARCHES_DICTIONARY = gql(/* GraphQL */ `
  query GetPropertySearchesDictionary {
    sources: dictionaries(
      where: {
        type: { _eq: enums }
        name: { _like: "property_search_source.%" }
      }
    ) {
      id
      name
      label
    }

    aggregator_sources: dictionaries(
      where: {
        type: { _eq: enums }
        name: { _like: "property_search_aggregator_source.%" }
      }
    ) {
      id
      name
      label
    }
  }
`);
